module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/jan-wagner-a5d99873dbc6eadc17dbbe361ab357d1.webp";